import { axiosEduServer } from "../utils/configAxios";

export const crearTurno = (data) => {
  return axiosEduServer.post('/turno', data).then(({ data }) => data).catch((err) => { console.log(err); throw err });
};

export const actualizarTurno = (id, data) => {
  return axiosEduServer.put(`/turno/${id}`, data).then(({ data }) => data).catch((err) => { console.log(err); throw err });
};

export const eliminarTurno = (id) => {
  return axiosEduServer.delete(`/turno/${id}`).then(({ data }) => data).catch((err) => { console.log(err); throw err });
};

export const getOneTurno = (id) => {
  return axiosEduServer.get(`/turno/${id}`).then(({ data }) => data).catch((err) => { console.log(err); throw err });
};

export const getAllTurnos = () => {
  return axiosEduServer.get('/turno').then(({ data }) => data).catch((err) => { console.log(err); throw err });
};